var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldFolderConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16c2.8 0 3.5-.7 3.5-3.5V8.3c0-2.8-.7-3.5-3.5-3.5h-2.1c-.7 0-.85-.21-1.12-.56l-1.05-1.4c-.4-.53-.63-.84-1.68-.84H8.5C5.7 2 5 2.7 5 5.5v7c0 2.8.7 3.5 3.5 3.5h2.75v3c0 .05.02.09.03.14a2 2 0 0 0-1.14 1.14c-.05-.01-.09-.03-.14-.03H6c-.41 0-.75.34-.75.75s.34.75.75.75h4c.05 0 .09-.02.14-.03a1.992 1.992 0 0 0 3.72 0c.05.01.09.03.14.03h4c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4c-.05 0-.09.02-.14.03a2 2 0 0 0-1.14-1.14c.01-.05.03-.09.03-.14v-3h2.75z",
    fill: "{props.color}",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldFolderConnection);
export default __webpack_public_path__ + "static/media/vuesax-bold-folder-connection.dcb3b1b46faf89b052f6423960df3274.svg";
export { ForwardRef as ReactComponent };